module.exports = __webpack_public_path__ + "static/media/icon-of-christ.7006c9fc.jpg";